import { stringify } from 'query-string';

import { entityTypeToApiType } from 'helpers/mapEntityTypes';

import { TopicFilterNames } from 'components/TopicFilters/shared';
import { EntityTypes } from 'context/entityContext';
import getRegionBreakdown from 'helpers/getRegionBreakdown';
import getCountryIds from 'helpers/getCountryIds';

export interface IPlaylistKPIURLArgs {
  countryIds?: string[];
  customerFilter?: TopicFilterNames[];
  download?: boolean;
  entityType: EntityTypes;
  entityIds: string[];
  region?: string;
  customRegion?: string | string[];
  compareMode?: string;
}

export default function getPlaylistKPIURL(args: IPlaylistKPIURLArgs): string {
  const {
    countryIds,
    customerFilter,
    download,
    entityType,
    entityIds,
    region,
    customRegion,
    compareMode,
  } = args;
  const type = entityTypeToApiType(entityType);

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    customerFilter,
    download,
    regionBreakdown: getRegionBreakdown(
      countryIds,
      region,
      compareMode,
      customRegion
    ),
  });

  return `/api/playlist/kpi/${type}/${entityIds}?${params}`;
}
